import { isAutoVehicleComplete } from './vehicleCompleteness.js';
import { isMarineVehicleComplete } from './marineService.js';
import { isMarineVehicle } from './assetType.js';

/**
 * Is this vehicle chosen completely enough to read the service catalog for?
 *
 * The services step refetches on every change to the vehicle prop, and the
 * cascade emits a NEW vehicle after each dropdown — so without this the fetch
 * fired on year, then make, then model, then trim, before there was anything to
 * filter on. Those requests went out with an empty `vehicleSize` and no
 * `bodyStyle`.
 *
 * **Read the catalog only once the vehicle is fully selected**, for auto and
 * marine alike. A half-chosen vehicle does not merely fail — it can SUCCEED and
 * return the wrong catalog: `catalogFilterParams` falls back to `vehicleSize`
 * when there is no body style, so a vehicle with a size but no trim would fetch
 * a plausible-looking list filtered on the wrong axis.
 *
 * Reuses the SAME predicates that gate the Next button rather than inventing a
 * looser rule, so the catalog can never be read for a vehicle the wizard itself
 * considers unfinished. Two rules for one question is how they drift.
 *
 * The two branches genuinely differ: a boat has no trim, body style or
 * `id_car_trim` — the marine catalog is keyed on `assetType` + `vehicle_size`
 * 'SF' — so the automotive gate would block it forever.
 *
 * Imports only zero-import modules, so this stays harness-testable
 * (`scripts/test/catalogReadiness.test.mjs`). The `.js` extensions are required:
 * Node's ESM resolver does not guess them and webpack does not mind.
 */
export function isVehicleReadyForCatalog(vehicle) {
  if (!vehicle || typeof vehicle !== 'object') return false;
  return isMarineVehicle(vehicle)
    ? isMarineVehicleComplete(vehicle)
    : isAutoVehicleComplete(vehicle);
}

const catalogReadiness = { isVehicleReadyForCatalog };
export default catalogReadiness;
